import {filter, from, mergeMap, Observable, withLatestFrom} from "rxjs";
import { Action } from "@reduxjs/toolkit";
import {registerFiles, addFiles} from "../slices";
import {selectFiles} from "../selectors";

export const registerEpic = (
  action$: Observable<Action>,
  state$: Observable<any>
) => {
  return action$.pipe(
    filter(registerFiles.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {

      const existingNames = new Set(selectFiles(state).map(f => f.name));

      const newFiles = action.payload.map(file => {
        if (!existingNames.has(file.name)) {
          existingNames.add(file.name);
          return file;
        }

        const nameParts = file.name.match(/^(.+?)(\.[^.]+)?$/);
        const baseName = nameParts?.[1] || file.name;
        const extension = nameParts?.[2] || '';

        let counter = 1;
        let newName = `${baseName} (${counter})${extension}`;

        while (existingNames.has(newName)) {
          counter++;
          newName = `${baseName} (${counter})${extension}`;
        }

        existingNames.add(newName);
        return new File([file], newName, { type: file.type });
      });

      return from([addFiles(newFiles)]);
    })
  );
};
